import React from "react";
import { StyleSheet, Text, View, } from "react-native";
import { Button } from "./Button";
export const ButtonConfirmWidget = ({ buttonText, schoolsText, onConfirm, containerStyle, buttonStyle, buttonTextStyle, schoolsTextStyle, iconColor, }) => (<View style={[styles.widget, containerStyle]}>
    <Text style={[styles.schoolsText, schoolsTextStyle]}>{schoolsText}</Text>
    <Button iconName="arrow-right" iconColor={iconColor} buttonText={buttonText} onPress={onConfirm} buttonStyle={[buttonStyle, styles.button]} buttonTextStyle={buttonTextStyle}/>
  </View>);
const styles = StyleSheet.create({
    widget: {
        position: "absolute",
        bottom: 0,
        left: 32,
        right: 32,
        height: 96,
        zIndex: 1000,
        borderRadius: 96,
        display: "flex",
        paddingLeft: 64,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    button: {
        position: "absolute",
        top: 8,
        right: 8,
        bottom: 8,
    },
    schoolsText: {
        fontSize: 20,
    },
});
//# sourceMappingURL=ButtonConfirmWidget.js.map